module.exports = __webpack_public_path__ + "static/img/8.0d96c7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/8.png
// module id = 2dQ7
// module chunks = 0